import apiClient from '../utils/api/ApiClient';
import { API_ENDPOINTS } from '../constants/api.constants';
import type {
    CatalogueResponse,
    StarterDetail,
    StarterListResponse,
    StarterUpdateBody,
    StarterWriteBody,
} from '../types/accessManagement.types';

type Envelope<T> = { status: string; message?: string; data: T };

const PATHS = API_ENDPOINTS.DESIGNATION_TEMPLATE;

function asRecord(value: unknown): Record<string, unknown> | undefined {
    return value && typeof value === 'object' ? (value as Record<string, unknown>) : undefined;
}

export function starterSaveError(err: unknown): { message: string; nameClash: boolean } {
    const root = asRecord(err);
    const payload = asRecord(root?.data);
    const serverMessage = typeof payload?.message === 'string' ? payload.message.trim() : '';
    const statusCode = typeof root?.status === 'number' ? root.status : undefined;
    return {
        message: serverMessage || 'The starter was not saved.',
        nameClash: statusCode === 409 || /already exists/i.test(serverMessage),
    };
}

export async function listStarters(): Promise<StarterListResponse> {
    const response = await apiClient.post<Envelope<StarterListResponse>>(PATHS.LIST, {});
    return response.data;
}

export async function getStarterDetails(templateId: string): Promise<StarterDetail> {
    const response = await apiClient.post<Envelope<StarterDetail>>(PATHS.DETAILS, { templateId });
    return response.data;
}

export async function getStarterCatalogue(): Promise<CatalogueResponse> {
    const response = await apiClient.post<Envelope<CatalogueResponse>>(PATHS.CATALOGUE, {});
    return response.data;
}

export async function createStarter(body: StarterWriteBody): Promise<StarterDetail> {
    const response = await apiClient.post<Envelope<StarterDetail>>(PATHS.CREATE, body);
    return response.data;
}

export async function updateStarter(body: StarterUpdateBody): Promise<StarterDetail> {
    const response = await apiClient.post<Envelope<StarterDetail>>(PATHS.UPDATE, body);
    return response.data;
}
